import { gql } from '@apollo/client';

const GET_WORKOUT_NEW = gql`
  query GetWorkout($workoutId: String!) {
    workout(workoutId: $workoutId) {
      programName
      workoutName
      imageWide
      equipment
      categories
      fitnessLevel
      durationInSeconds
      name
      id
      vimeoId
      tiers
      embedUrl
      description
      tracks {
        presenters
        name
        duration
        durationInSeconds
        startTime
        trackNumber
        keyMovements
        music {
          musicCoverArtist
          musicCoverType
          musicOriginalArtist
          musicTitle
        }
      }
      assets {
        videoId
        workoutId
        name
        product
        provider
        streamUrl
        metaData
        workoutName
      }
    }
  }
`;

export default GET_WORKOUT_NEW;
